const localizationConstants: { [key: string]: string } = {
	dashboardTitle: 'dashboardTitle',
	company: 'company',
	home: 'home'
};
export default localizationConstants;
